import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '127.0.0.1:8000',
    method: 'post',
    params: query
  })
}
